var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_1954)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2646 0.636353C13.6214 0.636353 12.2894 1.9684 12.2894 3.61156V5.09916H9.31418V8.07437C9.31418 8.89595 9.98021 9.56197 10.8018 9.56197H22.7026C23.5242 9.56197 24.1902 8.89595 24.1902 8.07437V5.09916H21.215V3.61156C21.215 1.9684 19.883 0.636353 18.2398 0.636353H15.2646ZM15.2646 5.09916C15.2646 4.27758 15.9306 3.61156 16.7522 3.61156C17.5738 3.61156 18.2398 4.27758 18.2398 5.09916C18.2398 5.92074 17.5738 6.58677 16.7522 6.58677C15.9306 6.58677 15.2646 5.92074 15.2646 5.09916Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6943 14.3967V20.719H22.9505V21.4628H23.6943V27.7851H17.372V27.0413H16.6282V27.7851H10.3059V21.4628H11.0497V20.719H10.3059V14.3967H16.6282V15.1405H17.372V14.3967H23.6943ZM17.372 16.6281H16.6282V18.1157H17.372V16.6281ZM17.372 19.6033H16.6282V20.719H15.5125V21.4628H16.6282V22.5785H17.372V21.4628H18.4877V20.719H17.372V19.6033ZM16.6282 24.0661H17.372V25.5537H16.6282V24.0661ZM12.5373 21.4628V20.719H14.0249V21.4628H12.5373ZM19.9753 21.4628V20.719H21.4629V21.4628H19.9753Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36377 6.58677H7.82658V8.07437C7.82658 9.71753 9.15862 11.0496 10.8018 11.0496H22.7026C24.3458 11.0496 25.6778 9.71753 25.6778 8.07437V6.58677H30.1406V33.3636H3.36377V6.58677ZM8.81832 12.9091H25.182V29.2727H8.81832V12.9091Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_1954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7273,
    height: 32.7273,
    fill: "white",
    transform: "translate(0.636475 0.636353)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellReport);
export default __webpack_public_path__ + "static/media/WellReport.b2713ead76732adf53467c3ff436e1c5.svg";
export { ForwardRef as ReactComponent };